import { HighchartsBuilder } from './highcharts.builder';

export interface HighchartsDirectorInputs {}

export abstract class HighchartsDirector<T extends HighchartsDirectorInputs> {
  protected readonly builder: HighchartsBuilder = new HighchartsBuilder();

  abstract construct(inputs: T): Highcharts.Options;
}
